// extracted by mini-css-extract-plugin
export default {"toster":"Toster_toster__8Vsp4","error":"Toster_error__XB06H","correct":"Toster_correct__lWJHX"};